import $ from 'jquery'
import Recaptcha from '../../utils/recaptcha'
import ScrollHelper from '../../utils/scroll-helper'
import gsap from 'gsap'
import { CLEVERREACH_SITE_KEY } from '../../constants/recaptcha'

const ACTIVE_CLASS = 'testimonial--form-active'
const INVALID_CLASS = 'is-invalid'
const BTN_DISABLED_CLASS = 'btn--outline'

class Testimonials {
  constructor(selector = '.testimonial') {
    this.items = $(selector)

    this.init()
  }

  init() {
    this.items.each((index, item) => new Testimonial(item, index))
  }
}

class Testimonial {
  constructor(item, index) {
    this.index = index
    this.item = $(item)
    this.formContainer = $('.testimonial__form', item)
    this.trigger = $('.testimonial__form-trigger', item)
    this.close = $('.testimonial__form-close', item)

    this.form = $('form', item)
    this.textInputs = $('.form-control', this.form)
    this.checkboxInputs = $('.form-check-input', this.form)
    this.inputs = this.textInputs.add(this.checkboxInputs)

    this.inputCounters = $('.form-control.form-control--has-counter', this.form)

    this.recaptchaContainer = $('.g-recaptcha', this.form).get(0)
    this.submitButton = $('.form-action .btn', this.form)

    this.isActive = false
    this.recaptchaValid = false
    this.animation = this.createAnimation()

    // If we dont have a form we just return
    if (!this.formContainer.length) {
      return
    }

    this.initRecaptcha()
    // this.initInputCounters()
    this.sanatizeInputLabelRelations()

    this.listen()
    this.listenForm()
  }

  listen() {
    this.trigger.on('click', () => {
      this.activateForm()
    })

    this.close.on('click', event => {
      event.preventDefault()
      event.stopImmediatePropagation()
      this.deactivateForm()
    })
  }

  listenForm() {
    this.form.on('submit', event => {
      this.submit(event)
    })

    // validate on focus out events
    this.textInputs.on('blur', event => {
      this.showInputsValidationStatus(event.target)
    })

    // validate on click events
    this.checkboxInputs.on('click', event => {
      this.showInputsValidationStatus(event.target)
    })

    // make submit button be aware of all inputs
    this.inputs.on('input', () => {
      this.setSubmitButtonState()
    })
  }

  createAnimation() {
    // only create timeline if we need that for existing elements
    if (!this.trigger.length || !this.formContainer.length) {
      return null
    }

    const tl = gsap.timeline({
      onComplete: () => {
        // Remove the inline hcss style after anmation finished
        this.formContainer.css('height', '')
      },
    })
    // Stop the timeline
    tl.pause()
    // Animate the trigger button
    tl.to(this.trigger, {
      duration: 0.3,
      height: 0,
      opacity: 0,
      ease: 'sine.inOut',
    })
    // animate the form container
    tl.from(this.formContainer, {
      duration: 0.3,
      height: 0,
      opacity: 0,
      ease: 'sine.inOut',
    })

    return tl
  }

  activateForm() {
    this.formContainer.css('height', this.formContainer.height())
    this.animation.play()
    this.item.addClass(ACTIVE_CLASS)
    this.isActive = true
  }

  deactivateForm() {
    this.animation.reverse()
    this.item.removeClass(ACTIVE_CLASS)
    this.isActive = false
    // scroll to top of element
    ScrollHelper.scrollToElement(this.item)
  }

  sanatizeInputLabelRelations() {
    this.inputs.toArray().forEach(input => {
      const key = $(input).attr('id') + '-' + this.index
      $(input)
        .attr('id', key)
        .next('label')
        .attr('for', key)
    })
  }

  submit(event) {
    event.preventDefault()
    const valid = this.validateForm()

    if (valid) {
      return this.form.get(0).submit()
    }

    this.showInputsValidationStatus(this.inputs)
    this.scrollToFirstInvalidInput()
  }

  scrollToFirstInvalidInput() {
    const el = $('.is-invalid', this.form).first()
    ScrollHelper.scrollToElement(el)
  }

  getRequiredInputsValidationStatus() {
    const requiredInputs = $('input[required]', this.form).toArray()

    return requiredInputs.every(input => {
      return input.validity.valid
    })
  }

  showInputsValidationStatus(inputs) {
    // wrap the inputs as jquery object to handle single & array values
    $(inputs)
      .toArray()
      .forEach(input => {
        !input.validity.valid
          ? $(input).addClass(INVALID_CLASS)
          : $(input).removeClass(INVALID_CLASS)
      })
  }

  validateForm() {
    return this.getRequiredInputsValidationStatus() && this.recaptchaValid
  }

  setSubmitButtonState() {
    !this.validateForm()
      ? this.submitButton.addClass(BTN_DISABLED_CLASS)
      : this.submitButton.removeClass(BTN_DISABLED_CLASS)
  }

  // initInputCounters() {
  //   this.inputCounters.each((index, input) => {
  //     const field = $(input)
  //     const counter = $('.form-control__counter', field.parent())

  //     field.on('input', event => {
  //       const inputLength = event.target.value.length
  //       counter.text(inputLength)
  //     })
  //   })
  // }

  initRecaptcha() {
    Recaptcha.render(
      this.recaptchaContainer,
      CLEVERREACH_SITE_KEY,
      this.recaptchaSuccess.bind(this),
      this.recaptchaExpired.bind(this)
    )
  }

  recaptchaSuccess() {
    this.recaptchaValid = true
    this.setSubmitButtonState()
  }

  recaptchaExpired() {
    this.recaptchaValid = false
    this.setSubmitButtonState()
  }
}

export default Testimonials
